export enum TransferMode {
	SINGLE = 'single',
	ALL_BUT_DEFAULT = 'allButDefault',
	ALL = 'all'
}

